import type { useFetchBuilderSession } from '../builder-session/useFetchBuilderSession'
import type { useFetchBrowserSession } from '../browser-session/useFetchBrowserSession'

export const createQueryComposable = (useFetchSession: typeof useFetchBuilderSession | typeof useFetchBrowserSession) => {
  const getCurrent = ({ immediate = true }: { immediate?: boolean } = {}) => {
    const { getCurrent } = (useFetchSession as typeof useFetchBuilderSession)()

    return useAsyncState(getCurrent, undefined, { immediate })
  }

  return {
    getCurrent,
  }
}
